import React from 'react';

import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

import { formatPrice } from '@shared/helpers';

import cls from './FinancialIndicatorsDiagramLine.module.css';
import { useFinancialIndicatorsDiagramLine } from './useFinancialIndicatorsDiagramLine';

interface FinancialIndicatorsDiagramLineProps {
    classes?: string;
    value?: number;
    maxCosts: string;
    valueSign: string;
    colorType: string;
    percent: number;
}

enum FinancialDiagramDescription {
    REVENUE = i18next.t('FinancialIndicatorsDiagramLine.return.enum.revenue'),
    EXPENSES = i18next.t('FinancialIndicatorsDiagramLine.return.enum.expenses'),
}

export const FinancialIndicatorsDiagramLine = ({
    classes,
    value,
    valueSign,
    maxCosts,
    colorType,
    percent,
}: FinancialIndicatorsDiagramLineProps) => {
    const { width, diagramRef, notShowDescription } = useFinancialIndicatorsDiagramLine({
        value,
        maxCosts,
    });

    return (
        <>
            {notShowDescription && (
                <ReactTooltip
                    id={`diagramValue-${value}`}
                    aria-haspopup="true"
                    effect="solid"
                    delayHide={200}
                    delayShow={200}
                    type="light"
                    className={cls.tooltip}
                >
                    <p>
                        {colorType === 'primary'
                            ? FinancialDiagramDescription.REVENUE
                            : FinancialDiagramDescription.EXPENSES}
                    </p>
                </ReactTooltip>
            )}
            <div className={classNames(cls.FinancialIndicatorsDiagramLine, [classes])}>
                <div
                    data-tip
                    data-for={`diagramValue-${value}`}
                    ref={diagramRef}
                    className={classNames(cls.DiagramLine, {
                        [cls.primary]: colorType === 'primary',
                        [cls.secondary]: colorType === 'secondary',
                    })}
                    style={{ '--target-width': `${percent}%` }}
                >
                    {!notShowDescription && (
                        <span className={classNames(cls.DiagramDescription)}>
                            {colorType === 'primary'
                                ? FinancialDiagramDescription.REVENUE
                                : FinancialDiagramDescription.EXPENSES}
                        </span>
                    )}
                </div>
                <span className={cls.Value}>
                    {formatPrice(Math.round(value), {
                        withCurrency: true,
                        currencySign: valueSign,
                    })}
                </span>
            </div>
        </>
    );
};
